// apps/client/src/stores/uiStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  sidebarCollapsed:   boolean;
  sidebarMobileOpen:  boolean;
  toggleSidebar:      () => void;
  setSidebarCollapsed:(v: boolean) => void;
  setMobileOpen:      (v: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed:  false,
      sidebarMobileOpen: false,
      toggleSidebar:       () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
      setMobileOpen:       (v) => set({ sidebarMobileOpen: v }),
    }),
    { name: 'yogo-ui' },
  ),
);

// Day 14 complete
